import React from 'react';
import SectionIncomingConsignment from '../SectionIncomingConsignment';

const GreigeIncomingConsignment = () => {
  return (
    <SectionIncomingConsignment 
      sectionName="Greige"
      sectionDisplayName="Greige"
      backRoute="/sections/greige"
    />
  );
};

export default GreigeIncomingConsignment;
